import React, { useState, useEffect } from 'react';
import { Trash2 } from 'lucide-react';
import { adminStatsService } from '../../../services/adminStatsService';
import { useSeasonContext } from '../../../context/SeasonContext';

const Block247SportsItemBlock = ({ block, onUpdate, onDelete }) => {
  const [players, setPlayers] = useState([]);
  const [teams, setTeams] = useState([]);
  const { selectedSeason } = useSeasonContext();

  useEffect(() => {
    if (selectedSeason?.id) {
      fetchData();
    }
  }, [selectedSeason?.id]);

  const fetchData = async () => {
    try {
      const playerList = await adminStatsService.getPlayersForSeason(selectedSeason.id);
      setPlayers(playerList);
      const uniqueTeams = [...new Set(playerList.map(p => p.team).filter(Boolean))].sort();
      setTeams(uniqueTeams);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handlePlayerChange = (playerName) => {
    const selectedPlayer = players.find(p => p.name === playerName);
    onUpdate(block.id, {
      name: playerName,
      team: selectedPlayer?.team || ''
    });
  };

  return (
    <div className="block-item block247-block">
      <div className="block-header">
        <span>247Sports</span>
        <button
          type="button"
          className="btn-icon-small delete"
          onClick={() => onDelete(block.id)}
        >
          <Trash2 size={16} />
        </button>
      </div>
      <select
        value={block.type || 'player'}
        onChange={(e) => onUpdate(block.id, { type: e.target.value })}
        className="field-select"
      >
        <option value="player">Player</option>
        <option value="team">Team</option>
      </select>
      {block.type === 'player' ? (
        <>
          <select
            value={block.name || ''}
            onChange={(e) => handlePlayerChange(e.target.value)}
            className="field-select"
          >
            <option value="">Select player</option>
            {players.map((player) => (
              <option key={player.name} value={player.name}>
                {player.name}
              </option>
            ))}
          </select>
          <input
            type="text"
            placeholder="Team"
            value={block.team || ''}
            disabled
            className="field-input"
          />
        </>
      ) : (
        <select
          value={block.name || ''}
          onChange={(e) => onUpdate(block.id, { name: e.target.value })}
          className="field-select"
        >
          <option value="">Select team</option>
          {teams.map((team) => (
            <option key={team} value={team}>
              {team}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};

export default Block247SportsItemBlock;
